import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import { GET_PROGRAM_EVENT_ACTIVITIES, GET_PROGRAM_EVENT_ACTIVITIES_ERROR, GET_PROGRAM_EVENT_ACTIVITIES_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* getProgramEventActivities({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/event-activity`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_PROGRAM_EVENT_ACTIVITIES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PROGRAM_EVENT_ACTIVITIES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PROGRAM_EVENT_ACTIVITIES_ERROR, payload: error });
  }
}

export function* watchGetProgramEventActivities() {
  yield takeEvery(GET_PROGRAM_EVENT_ACTIVITIES, getProgramEventActivities);
}

function* getProgramEventActivitiesSaga() {
  yield all([fork(watchGetProgramEventActivities)]);
}

export default getProgramEventActivitiesSaga;
